import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext();

function normalizeUser(u) {
  if (!u) return u;
  const initials = u.avatar || (u.name ? u.name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase() : '?');
  return { ...u, initials };
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('ryzenos_session')) || null; } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  // On mount -- if we have a token, verify it's still valid against the backend
  useEffect(() => {
    const token = api.getToken();
    if (!token) { setLoading(false); return; }
    api.auth.me()
      .then(({ user: freshUser }) => {
        const normalized = normalizeUser(freshUser);
        sessionStorage.setItem('ryzenos_session', JSON.stringify(normalized));
        setUser(normalized);
      })
      .catch(() => {
        // Token invalid/expired -- already handled by api client (redirects to login)
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (usernameOrEmail, password) => {
    try {
      const { token, user: loggedInUser } = await api.auth.login(usernameOrEmail, password);
      const normalized = normalizeUser(loggedInUser);
      api.setToken(token);
      sessionStorage.setItem('ryzenos_session', JSON.stringify(normalized));
      setUser(normalized);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message || 'Invalid username or password' };
    }
  };

  const logout = () => {
    api.setToken(null);
    sessionStorage.removeItem('ryzenos_session');
    setUser(null);
    window.location.href = '/login';
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
